import { useState } from 'react';

export default function Step3_Experience({ data, onChange, onNext, onBack }) {
    const [errors, setErrors] = useState({});
    const set = (field, val) => onChange({ ...data, [field]: val });

    const validate = () => {
        const e = {};
        if (!data.motivation?.trim() || data.motivation.trim().length < 20)
            e.motivation = 'لطفاً حداقل ۲۰ کاراکتر بنویسید';
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    return (
        <div>
            <h2 className="aaw-step-title">سابقه و انگیزه</h2>
            <p className="aaw-step-desc">تجربه کاری و دلایل علاقه‌مندی خود را شرح دهید.</p>

            <div className="aaw-field">
                <label className="aaw-label">سال‌های سابقه کاری در حوزه املاک</label>
                <div className="aaw-counter">
                    <button
                        type="button"
                        onClick={() => set('years_of_experience', Math.max(0, (data.years_of_experience || 0) - 1))}
                        disabled={(data.years_of_experience || 0) === 0}
                    >−</button>
                    <span className="aaw-counter-val">{data.years_of_experience || 0}</span>
                    <button
                        type="button"
                        onClick={() => set('years_of_experience', Math.min(50, (data.years_of_experience || 0) + 1))}
                    >+</button>
                    <span style={{ fontSize: '0.85rem', color: '#78909c', marginRight: 8 }}>سال</span>
                </div>
            </div>

            <div className="aaw-field">
                <label className="aaw-label">انگیزه و توضیحات *</label>
                <textarea
                    className={`aaw-textarea ${errors.motivation ? 'error' : ''}`}
                    value={data.motivation || ''}
                    onChange={e => set('motivation', e.target.value)}
                    placeholder="چرا می‌خواهید نماینده شوید؟ چه تجربه‌ای دارید؟"
                    rows={5}
                />
                {errors.motivation && <span className="aaw-field-error">{errors.motivation}</span>}
                <span style={{ fontSize: '0.75rem', color: '#90a4ae', marginTop: 2 }}>
                    {(data.motivation || '').length} کاراکتر
                </span>
            </div>

            <div className="aaw-nav">
                <button className="aaw-btn aaw-btn-secondary" onClick={onBack}>→ مرحله قبل</button>
                <button className="aaw-btn aaw-btn-primary" onClick={() => { if (validate()) onNext(); }}>
                    مرحله بعد ←
                </button>
            </div>
        </div>
    );
}
